export default __webpack_public_path__ + "b89e27eba695f55ccf9569b4eb4413e0.png";